// import { $req } from "../utils";
import request from '../utils/request'
export default {
	/*-------------------------------------------------------------销售配置start-----------------------------------------------------------  */
	//版本号列表查询接口-姜飞
	queryVersionList({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/system/queryVersionList`,
			data: params
		})
	},
	//V2.0-(首页)领域、入口下多部门存在检查-李旭
	findMultiDepartCheck({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/multiDepart/check`,
			data: params
		})
    },
	//报表入口接口-田海光
	findConfigurationInfo({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/findConfigurationInfo`,
			data: params
		})
    },
    //查看下级填报状态接口-田海光
	subordinateFillStatus({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/subordinateFillStatus`,
			data: params
		})
	},
	/*------------------------------------------------------------ 销售配置end-------------------------------------------------------------  */
	//销售-渠道-历史销量趋势查询
	getChannel({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/channel/query`,
			data: params
		})
	},
	/*------------------------------------------------------------ 渠道收入Start-------------------------------------------------------------  */
	// 收入查询表地址查询 - 李旭
	queryImcomeReportUrl({ ...params }){
		return request({
			method: 'GET',
			url: `/bpc/income/queryImcomeReportUrl`,
			params: params
		})
	},
	// 销售-渠道-删除药品
	delMaterial({ ...params }){
		return request({
			method: 'POST',
			url: `/bpc/income/channel/addOrDelMaterial`,
			data: params
		})
	},
	// 销售-渠道-收入查看
	checkChannelCome({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/channel/query`,
			data: params
		})
	},
	// 销售-渠道-保存
	saveChannelIncome({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/channel/save`,
			data: params
		})
	},
	// 销售-渠道-模板导入
	channelTemplate({ ...params }) {
		return request({
			method: 'GET',
			url: `/bpc/income/channel/downloadTemplet`,
			data: params
		})
	},
	/*------------------------------------------------------------ 渠道收入end-------------------------------------------------------------  */
	/*------------------------------------------------------------ 基层收入Start-------------------------------------------------------------  */
	// 销售-渠道-收入查看
	checkBasic({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/grassRoot/query`,
			data: params
		})
	},
	// 销售-渠道-保存
	saveBasic({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/grassRoot/save`,
			data: params
		})
	},
	// 删除产品
	delBasicMaterial({ ...params }){
		return request({
			method: 'POST',
			url: `/bpc/income/grassRoot/addOrDelMaterial`,
			data: params
		})
	},
	// 删除省份
	basicDelPrv(params){
		return request({
			method: 'POST',
			url: `/bpc/income/grassRoot/deleteProvince`,
			data: params
		})
	},
	/*------------------------------------------------------------ 基层收入end-------------------------------------------------------------  */
	/*------------------------------------------------------------ 战略收入Start-------------------------------------------------------------  */
	// 战略-填报
	fillStrategy({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/challengeIndicatorsIncome/queryInitChallengeIndicatorsIncome`,
			data: params
		})
	},
	// 战略-收入查看
	checkStrategy({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/challengeIndicatorsIncome/queryChallengeIndicatorsIncome`,
			data: params
		})
	},
	// 战略-保存
	saveStrategy({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/challengeIndicatorsIncome/save`,
			data: params
		})
	},
	/*------------------------------------------------------------ 战略收入end-------------------------------------------------------------  */
	/*------------------------------------------------------------ 二次议价start------------------------------------------------------------  */
	//查询二次议价大区/事业部收入数据
	getDeptBargainIncome({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/bargainIncome/queryDeptBargainIncome`,
			data: params
		})
	},
	//保存大区二次议价收入填报
	saveDeptBargainIncome({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/bargainIncome/saveDeptBargainIncome`,
			data: params
		})
	},
	//查询销售-查询二次议价区域收入数据-姜飞
	getAreaBargainIncome({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/bargainIncome/queryAreaBargainIncome`,
			data: params
		})
	},
	//查询销售-保存二次议价收入填报-姜飞
	saveAreaBargainIncome({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/bargainIncome/save`,
			data: params
		})
	},
	/*-------------------------------------------------------------二次议价end-----------------------------------------------------------  */
	/*-------------------------------------------------------------返利start-----------------------------------------------------------  */

	//查询销售-返利收入填报数据-姜飞
	getAreaRebateIncome({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/rebateIncome/queryAreaRebateIncome`,///bpc/income/queryAreaRebateIncome
			data: params
		})
	},
	
	
	// 保存返利收入填报-姜飞
	saveAreaRebateIncome({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/rebateIncome/save`,
			data: params
		})
	},
	// 销售-返利收入填报初始数据-姜飞
	getInitAreaRebateIncome({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/queryInitAreaRebateIncome`,
			data: params
		})
    },
	/*-------------------------------------------------------------返利end-----------------------------------------------------------  */
	/*----------------------------------------------------------原料药start-----------------------------------------------------------  */
	//原料药销售-填报-姜飞
	getRawMaterialSalesIncome({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/materialIncome/queryRawMaterialSalesIncome`,
			data: params
		})
	},
	//保存原料药销售收入填报
	saveRawMaterialIncome({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/materialIncome/save`,
			data: params
		})
	},
	//查看原料药出口及加工收入
	getRawMaterialExportIncome({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/materialExportIncome/queryRawMaterialExportIncome`,
			data: params
		})
	},
	//保存原材料出口及代加工收入预算填报
	saveRawMaterialExportIncome({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/materialExportIncome/save`,
			data: params
		})
	},
	//获取原材料主数据
	getSubstanceDrug({ ...params }) {
		return request({
			method: 'GET',
			url: `/bpc/common/querySubstanceDrug`,
			params: params
		})
	},
   /*-----------------------------------------------------------原料药end-----------------------------------------------------------  */
	/*-------------------------------------------------------------价格start-----------------------------------------------------------  */
    //销售-价格-中标价-初始化 - 李旭
    getDevelopDepartInit(params) {
		return request({
			method: 'POST',
            url: `/bpc/price/developDepart/init`,
            data: params
		})
	},
    //销售-价格-中标价-公发部查看 - 李旭
	getDevelopDepartList(params) {
		return request({
			method: 'POST',
			url: `/bpc/price/developDepart/query`,
			data: params
		})
	},
	//销售-价格-中标价-公发部导出 - 李旭
	exportDevelopDepart(params) {
		return request({
			method: 'GET',
			url: `/bpc/price/developDepart/export`,
			data: params
		})
	},
	//销售-价格-中标价-公发部填报-李旭
	addDevelopDepart(params) {
		return request({
			method: 'POST',
			url: `/bpc/price/developDepart/save`,
			data: params
		})
    },
    // 销售-价格-渠道开票价下浮比例列表 - 李旭
    getChannelInvoicePriceDownRatio(params) {
		return request({
			method: 'POST',
			url: `/bpc/price/channel/list`,
			data: params
		})
    },
    // 销售-价格-公发部预算中标价列表 - 李旭
    getDevelopDepartPredictBidPrice(params) {
		return request({
			method: 'POST',
			url: `/bpc/price/developDepart/list`,
			data: params
		})
    },
    // （废弃）销售-价格-综合折扣比例列表 - 李旭
    // getDiscountRatioList(params) {
	// 	return request({
	// 		method: 'GET',
	// 		url: `/bpc/price/discountRatio/query`,
	// 		data: params
	// 	})
    // },
    //销售-价格-开票价-渠道事业部查看 - 李旭
    getChannelList(params) {
		return request({
			method: 'POST',
			url: `/bpc/price/channel/query`,
			data: params
		})
    },
    //销售-价格-开票价-渠道事业部填报 - 李旭
    addChannel(params) {
		return request({
			method: 'POST',
			url: `/bpc/price/channel/save`,
			data: params
		})
    },
    //销售-价格-开票价-渠道事业部导出 - 李旭
    exportChannel(params) {
		return request({
			method: 'GET',
			url: `/bpc/price/channel/export`,
			data: params
		})
    },
    //销售-价格-中标价-纯销查看 - 李旭
    getPureSaleList(params) {
		return request({
			method: 'POST',
			url: `/bpc/price/pureSale/query`,
			data: params
		})
    },
     // 销售-价格-渠道删除 - 李旭
    channelDelete(params) {
		return request({
			method: 'POST',
			url: `/bpc/price/channel/delete`,
			data: params
		})
	},
	// 删除省份
	channelDelPrv(params){
		return request({
			method: 'POST',
			url: `/bpc/income/channel/deleteProvince`,
			data: params
		})
	},
    // 销售-价格-中标价-纯销填报 - 李旭
    addPureSale(params) {
		return request({
			method: 'POST',
			url: `/bpc/price/pureSale/save`,
			data: params
		})
    },
    //销售-价格-中标价-纯销导出 - 李旭
    exportPureSale(params) {
		return request({
			method: 'GET',
			url: `/bpc/price/pureSale/export?configurationId=`,
			data: params
		})
    },
     // 销售-价格-纯销删除 - 李旭
     pureSaleDelete(params) {
		return request({
			method: 'POST',
			url: `/bpc/price/pureSale/delete`,
			data: params
		})
    },
    //销售-价格-中标价-基层查看 - 李旭
    getBaseList(params) {
		return request({
			method: 'POST',
			url: `/bpc/price/base/query`,
			data: params
		})
    },
    //销售-价格-中标价-基层填报 - 李旭
    addBase(params) {
		return request({
			method: 'POST',
			url: `/bpc/price/base/save`,
			data: params
		})
    },
    //销售-价格-中标价-基层导出 - 李旭
    exportBase(params) {
		return request({
			method: 'GET',
			url: `/bpc/price/base/export`,
			data: params
		})
    },
     // 销售-价格-基层删除 - 李旭
    baseDelete(params) {
		return request({
			method: 'POST',
			url: `/bpc/price/base/delete`,
			data: params
		})
    },
    //销售-价格-中标价-市场部查看 - 李旭
    getMarketList(params) {
		return request({
			method: 'POST',
			url: `/bpc/price/market/query`,
			data: params
		})
    },
    //销售-价格-中标价-市场部填报 - 李旭
    addMarket(params) {
		return request({
			method: 'POST',
			url: `/bpc/price/market/save`,
			data: params
		})
    },
    //销售-价格-中标价-市场部导出 - 李旭
    exportMarket(params) {
		return request({
			method: 'GET',
			url: `/bpc/price/market/export`,
			data: params
		})
    },
    /*-------------------------------------------------------------价格end-----------------------------------------------------------  */
	
	/*-------------------------------------------------------------市场部 start-----------------------------------------------------------  */
	//销售-市场部-收入填报查询-田海光
	getMarketIncome({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/marketDepart/query`,
			data: params
		})
	},
	//保存/发布市场部收入-田海光=
	saveMarketIncome({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/marketDepart/save`,
			data: params
		})
	},
	/*-------------------------------------------------------------市场部 end-----------------------------------------------------------  */
	/*-------------------------------------------------------------纯销 start-----------------------------------------------------------  */
	//销售-纯销-收入填报查询-田海光
	getPureSaleIncome({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/pure/query`,
			data: params
		})
	},
	//保存/发布-纯销-收入-田海光
	savePureSaleIncome({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/pure/save`,
			data: params
		})
	},
	/*-------------------------------------------------------------纯销 end-----------------------------------------------------------  */
	/*-------------------------------------------------------------历史销量趋势查询 start-----------------------------------------------------------  */
	//销售-市场部-历史销量趋势查询-田海光
	getMarketIncomeHistory({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/marketDepart/queryHistory`,
			data: params
		})
	},
	//销售-纯销-历史销量趋势查询-田海光
	getPureHistory({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/pure/queryHistory`,
			data: params
		})
	},
	//销售-渠道-历史销量趋势查询-田海光
	getChannelHistory({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/channel/queryHistory`,
			data: params
		})
	},
	//销售-基层-历史销量趋势查询-田海光
	getGrassRootHistory({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/grassRoot/queryHistory`,
			data: params
		})
	},
	/*-------------------------------------------------------------历史销量趋势查询 end-----------------------------------------------------------  */
	
	/*-------------------------------------------------------------管理平台 start-----------------------------------------------------------  */
	getbugetConfigTabList({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/manager/bugetConfigTabList`,
			data: params
		})
	},
	//修改报表填报日期接口-田海光
	modifyFillDate({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/manager/modifyFillDate`,
			data: params
		})
	},
	//修改报表填报日期接口-田海光
	modifyFillDate({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/manager/modifyFillDate`,
			data: params
		})
	},
	// 编辑版本时间接口（全量覆盖）-姜飞
	updBudgetVersion({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/system/updBudgetVersion`,
			data: params
		})
	},
	// 数仓报表部门查询接口
	queryDmrTableDepartList({ ...params }) {
		return request({
			method: 'GET',
			url: `/bpc/system/queryDmrTableDepartList`,
			params: params
		})
	},
	// 数仓报表配置表查询接口-田海光
	queryDmrTableConfig({ ...params }) {
		return request({
			method: 'GET',
			url: `/bpc/system/queryDmrTableConfig`,
			params: params
		})
	},
	// V2.0-预算填报进度查询-李旭
	managerBugetProcess({ ...params}) {
		return request({
			method: 'POST',
			url: `/bpc/manager/buget/progress`,
			data: params
		})
	},
	// v2.0 反馈
	bugetReview({ ...params}){
		return request({
			method: 'POST',
			url: `/bpc/manager/buget/review`,
			data: params
		})
	},
    /*-------------------------------------------------------------管理平台 end-----------------------------------------------------------  */
	//查询领域和入口配置数据
	getDomainConfig({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/manager/queryDomainConfig`,
			data: params
		})
	},
	//v3.0 报表填报人修改
	updateFillPerson({ ...params}){
		return request({
			method: 'POST',
			url: `/bpc/manager/updateFillPerson`,
			data: params
		})
	},
	//v3.0 报表是否代填修改
	updateDepartFlag({ ...params}){
		return request({
			method: 'POST',
			url: `/bpc/manager/updateDepartFlag`,
			data: params
		})
	},
	//v3.0 报表处理人修改
	updateReviewer({ ...params}){
		return request({
			method: 'POST',
			url: `/bpc/manager/updateReviewer`,
			data: params
		})
	},
	//v3.0 操作查看日志
	queryOperateLog({ ...params}){
		return request({
			method: 'GET',
			url: `/bpc/manager/queryOperateLog`,
			params: params
		})
	},
	//v3.0 批量变更时间
	updateFillDate({ ...params}){
		return request({
			method: 'POST',
			url: `/bpc/manager/updateFillDate`,
			data: params
		})
	},
	//v3.0 报表填报关闭
	operateBudgetStatus({ ...params}){
		return request({
			method: 'POST',
			url: `/bpc/manager/operateBudgetStatus`,
			data: params
		})
	},
    /*-------------------------------------------------------------通用 start-----------------------------------------------------------  */
	
    // 信息、工程、研发-项目列表 - 李旭
    projectList({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/project/list`,
			data: params
		})
    },
    
    // 信息-项目创建 - 李旭
    projectAdd({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/project/create`,
			data: params
		})
    },

    /*-------------------------------------------------------------通用 end-----------------------------------------------------------  */
    
    /*-------------------------------------------------------------税金 start-----------------------------------------------------------  */
    // 税金-商品税率列表 - 李旭
    taxList({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/tax/queryProductTax`,
			data: params
		})
	},
	
    /*-------------------------------------------------------------税金 end-----------------------------------------------------------  */

    /*-------------------------------------------------------------信息 start-----------------------------------------------------------  */
    // 信息-项目列表 - 李旭
    infoList({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/it/project/list`,
			data: params
		})
    },
    // 信息-信息项目主数据创建 - 李旭
    addInfo({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/it/project/create`,
			data: params
		})
    },
    // 信息-项目预算填报 - 李旭
    addIt({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/it/save`,
			data: params
		})
    },
    // 信息-项目预算查看 - 李旭
    getListIt({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/it/query`,
			data: params
		})
    },
    // 信息-项目预算删除 - 李旭
    deleteIt({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/it/delete`,
			data: params
		})
    },
    // 信息-项目预算导出 - 李旭
    exportIt({ ...params }) {
		return request({
			method: 'GET',
			url: `/bpc/it/export?configurationId=`,
			data: params
		})
    },
    // 信息-项目预算详情 - 李旭
    detailIt({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/it/detail`,
			data: params
		})
    },
    // 信息-项目预算发布 - 李旭
    publishIt(params) {
		return request({
			method: 'GET',
			url: `/bpc/it/publish?configurationId=`+params,
			data: ''
		})
	},
    /*-------------------------------------------------------------信息 end-----------------------------------------------------------  */
	
	/*-------------------------------------------------------------v2.0 纯销 收入 start-----------------------------------------------  */
	// 纯销-收入药品新增/删除 - 田海光
    deleteDrug({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/pure/addOrDelMaterial`,
			data: params
		})
	},
	// 纯销-收入删除省份 - 田海光
    deletePurseProvince({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/pure/deleteProvince`,
			data: params
		})
	},
	/*-------------------------------------------------------------v2.0 纯销 收入 end-------------------------------------------------  */
	/*-------------------------------------------------------------v2.0 渠道政策 start-----------------------------------------------  */
	// 销售-渠道政策填报-周安林
	policySave({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/channel/policy/save`,
			data: params
		})
	},
	//销售-渠道政策查看-周安林
	policyQuery({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/channel/policy/query`,
			data: params
		})
	},

    /*-------------------------------------------------------------v2.0 渠道政策 end-------------------------------------------------  */
	/*-------------------------------------------------------------v2.0 市场 收入 start-----------------------------------------------  */
	// 纯销-收入药品新增/删除 - 田海光
    addDeleteDrug({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/income/marketDepart/addOrDelMaterial`,
			data: params
		})
	},
	/*-------------------------------------------------------------v2.0 市场 收入 end-------------------------------------------------  */

	/*-------------------------------------------------------------v3.0 新品收集-------------------------------------------------  */
	// 新品收集填报查看 - 段舒皓
    queryList({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/newProduct/query`,
			data: params
		})
	},
	//新品收集发布 - 段舒皓
    saveProduct(params) {
		return request({
			method: 'POST',
			url: `/bpc/newProduct/saveProduct`,
			data: params
		})
    },
	// 新品收集删除
	delProduct(params) {
		return request({
			method: 'POST',
			url: `/bpc/newProduct/delete`,
			data: params
		})
	}
}